import { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ChallengeScheme, Track, ProductScheme } from "client-v2";
import { useDispatch, useSelector } from "react-redux";
import { actionsCreators, State } from "../../redux";
import { bindActionCreators } from "redux";

import Success from "../../components/section/success/Success";
import WizardContainer, {
	WizardContainerRef,
} from "../../components/container/WizardContainer";
import PaymentMethod from "../../components/section/donation/PaymentMethod";
import Price from "../../components/section/donation/Price";
import SuccessCrossSell from "../../components/section/success/SuccessCrossSell";
import Signature from "../../components/section/Signature";

const Checkout = (props: Props) => {
	const navigate = useNavigate();
	const location = useLocation();
	const dispatch = useDispatch();
	const { setShowError } = bindActionCreators(actionsCreators, dispatch);
	const isMobile: boolean = useSelector(
		(state: State) => state.screen.isMobile
	);
	const currentUser = useSelector((state: State) => state.user.currentUser);

	const wizard = useRef<WizardContainerRef>(null);

	const view = "signature";

	const [challenge, setChallenge] = useState<ChallengeScheme | undefined>(
		undefined
	);
	const [product, setProduct] = useState<ProductScheme | undefined>(
		undefined
	);

	useEffect(() => {
		//init
		if (location.state && location.state.challenge) {
			setChallenge(location.state.challenge);
		} else {
			navigate("/");
		}
	}, []);

	return (
		<WizardContainer
			ref={wizard}
			views={[
				//Signature
				{
					centralView: currentUser && challenge && (
						<Signature
							view={view}
							user={currentUser}
							challenge={challenge}
							onFinish={(result) => {
								if (result.error) {
									setShowError({
										show: true,
										message: result.error,
									});
								} else if (result.data) {
									wizard.current?.goNext();
								}
							}}
						/>
					),
				},
				//Price
				{
					centralView: challenge && (
						<Price
							challenge={challenge}
							view={view}
							defaultGrowthbook={{
								title: `Ayúdanos a seguir con nuestra misión`,
								title_en: `Help us continue with our mission`,
								subtitle:
									"Estás regalando {{data}} de compañía a una persona mayor",
								subtitle_en:
									"You are giving away {{data}} of company to a grandpa",
								type_to_eur: 0.602,
								type: "horas",
								type_en: "hours",
							}}
							options={["monthly", "annually", "unique"]}
							onSkip={() => wizard.current?.goNext(2)}
							onFinish={(result) => {
								if (result.error) {
									setShowError({
										show: true,
										message: result.error,
									});
								} else if (result.data) {
									setProduct(result.data);
									wizard.current?.goNext();
								}
							}}
						/>
					),
					// rightView: isMobile ? null : <PriceLeft />,
				},
				//Select payment method
				{
					centralView:
						product && currentUser && challenge ? (
							<PaymentMethod
								challenge={challenge}
								product={product}
								user={currentUser}
								view={view}
								onFinish={(result) => {
									if (result.error) {
										setShowError({
											show: true,
											message: result.error,
										});
									} else if (result.data) {
										wizard.current?.goNext();
									}
								}}
							/>
						) : null,
				},
				//Success view
				{
					centralView:
						currentUser && challenge ? (
							<>
								<Success
									title={`¡Gracias por firmar, ${currentUser.name}!`}
									subtitle="Hemos recibido tu firma. Gracias por ayudarnos a proteger los derechos de las personas mayores."
									type="challenge"
									user={currentUser}
									challenge={challenge}
									steps={[
										{
											title: "Seguiremos haciendo ruido",
											subtitle:
												"Para que la campaña llega a todo el mundo.",
										},
										{
											title: "Llegaremos hasta el final",
											subtitle:
												"En caso de conseguir todas las firmas lo llevaremos al organismo competente para conseguir el objetivo.",
										},
									]}
								/>
							</>
						) : null,
					rightView: !isMobile ? <SuccessCrossSell /> : null,
					hideBackButton: true,
				},
			]}
		/>
	);
};
export default Checkout;
export interface Props {}
